import { render } from "./FinishChangePosition.vue?vue&type=template&id=ebe31eba"
import script from "./FinishChangePosition.vue?vue&type=script&lang=js"
export * from "./FinishChangePosition.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__